import { routePath } from './lib/routes';

export const NAV_ITEMS = [
  { label: 'Products', href: `${routePath('home')}#features` },
  { label: 'Developers', href: routePath('developers') },
  { label: 'Pricing', href: routePath('pricing') },
  { label: 'Resources', href: '#' },
  { label: 'The Redirect', href: routePath('learn') },
];

/**
 * Flat product-page list. The desktop Products mega-menu (`ProductsMenu.tsx`)
 * keeps its own richer Core/Use-Cases structure; this is the simple list the
 * mobile menu and footer draw from so the feature pages are reachable on phones.
 */
export const PRODUCT_LINKS = [
  { label: 'Link Management', href: routePath('linkManagement') },
  { label: 'Smart Routing', href: routePath('smartRouting') },
  { label: 'Dynamic Responses', href: routePath('dynamicResponses') },
  { label: 'AI & MCP', href: routePath('aiMcp') },
  { label: 'Analytics', href: routePath('analytics') },
  { label: 'QR Codes', href: routePath('qrCodes') },
  { label: 'Custom Domains', href: routePath('customDomains') },
  { label: 'Integrations', href: routePath('integrations') },
];

/**
 * Resources dropdown / mobile Resources section. Real destinations only — add
 * Docs, Help, Changelog, Compare here as those pages ship.
 */
export const RESOURCE_LINKS = [
  { label: 'The Redirect', href: routePath('learn'), desc: 'Blog — playbooks & engineering notes' },
  { label: 'Developers', href: routePath('developers'), desc: 'REST API & MCP server' },
  { label: 'Changelog', href: routePath('changelog'), desc: 'What shipped — with receipts' },
  { label: 'Contact', href: routePath('contact'), desc: 'Talk to sales or support' },
];
